import HeroSection from "../../components/heroSection/HeroSectionCard";
import { useBrandConfig } from "../../queries/shared";
import {
  HeadingContainer,
  HeadingSubtitle,
  HeadingTitle,
} from "./HomePage.styles";
import { fetchProductListingData } from "../../api/ProductListAPI";
import { productEndPoints } from "../../constants/endpoints";
import { mapProducts } from "../../utils/productListMapping";
import { useEffect, useState } from "react";
import { ProductListingProps } from "../../types/ProductList";
import { Product as ProductType, ProductImage } from "../../api/homepage";
import ProductBanner from "../../components/homePage/ProductBanner";
import AboutUs from "../../components/homePage/AboutUsSection/AboutUs";
import TrackOrdersPayments from "../../components/trackOrdersPayments/TrackOrdersPayments";
import Box from "@mui/material/Box";

export default function HomePage() {
  const { data: brandConfig } = useBrandConfig();
  const { hero, prebook } = brandConfig ?? {};
  const [products, setProducts] = useState<ProductType[]>([]);

  // Interface for raw API products
  interface RawProduct {
    id: string;
    name: string;
    priceInCents: string | number;
    abv: number;
    description: string;
    imageMasterUrl: string;
    images: ProductImage[];
    showBuyButton: boolean;
    ibu?: number;
    basePrice?: number;
    ed?: number;
    preBookings?: boolean;
    displayInHomepage?: boolean;
    _id?: string;
    primaryButtonTitle?: string;
    secondaryButtonTitle?: string;
    displayInHome?: boolean;
    preorder?: boolean;
  }

  // Mapper function to convert raw API products to ProductType with /100 price conversion
  const mapRawProductsToProductType = (
    rawProducts: RawProduct[]
  ): ProductType[] => {
    return rawProducts.map((product) => ({
      ...product,
      priceInCents: String(Number(product.priceInCents) / 100),
    }));
  };

  useEffect(() => {
    const getProducts = async () => {
      try {
        const data = await fetchProductListingData(
          productEndPoints.getProducts
        );
        setProducts(mapRawProductsToProductType(data?.products || []));
      } catch (error) {
        console.error("Error fetching product listing", error);
      }
    };

    getProducts();
  }, []);

  return (
    <>
      <HeroSection hero={hero} prebookProducts={prebook ?? []} />
      <HeadingContainer>
        <HeadingTitle>What We Offer</HeadingTitle>
        <HeadingSubtitle>Check out our craft brews</HeadingSubtitle>
      </HeadingContainer>
      <ProductBanner products={products} />
      <TrackOrdersPayments />
      <Box id="about-us">
        <AboutUs />
      </Box>
    </>
  );
}
